$(document).on('turbolinks:load', function(){
  if ($('#invitation_sign_up_modal').length) {
    $('#invitation_sign_up_modal').modal('show');
  }
});